export default "__VITE_ASSET__InIG9k3s__"